<template>
    <div class="legislation">
        <Commondtitle title="法律法规" />
        <div class="le_content">
            <el-tabs v-model="activeName2" type="card">
                <el-tab-pane label="法律规章" name="first">
                    <legisChild  typeNum="B"/>
                </el-tab-pane>
                <el-tab-pane label="地方条律" name="second">
                   <legisChild typeNum="A"/>
                </el-tab-pane>
            </el-tabs>
        </div>
        <FriendLink />

    </div>
</template>

<script>
    import FriendLink from '../FriendLink'
    import Commondtitle from '../Commondtitle'
    import legisChild from '../legisChild'
    export default {
        name: "legislation",
        data(){
            return {
                activeName2: 'first',  //tab当前项
                fagui_btn: false, //法规更多数据
                tiaolv_btn: true, //条律更多数据
            }
        },
        mounted(){
        },
        methods:{

        },
        components:{
            Commondtitle,
            FriendLink,
            legisChild
        }
    }
</script>

<style scoped>
.legislation{
    width: 100%;
}
    .le_content{
        width: 1100px;
        margin: 0 auto;
    }
</style>